const projData = [
  {
    name: "Wasmcoex",
    description: "A plugin and library to convert Native C++ Android files to WebAssembly (Wasm). Enables cross-platform execution for Android projects using modern web technologies.",
    github: "https://github.com/prateekrai1/Wasmcoex"
  },
  {
    name: "Evaluating GPU Utilization in Serverless Function",
    description: "Research tool to analyze and optimize GPU utilization for serverless (FaaS) workloads. Helps benchmark computational efficiency and resource wastage in cloud-native environments.",
    github: "https://github.com/prateekrai1/Evaluating-utilization-of-GPUs-in-Serverless-Function"
  },
  {
    name: "Router CPU Prediction",
    description: "Machine learning model for real-time CPU utilization prediction on network routers, using time-series network data for resource aware networking.",
    github: "https://github.com/prateekrai1/Router-CPU-prediction"
  },
  {
    name: "Video Processing and Recommendation",
    description: "A platform for processing and recommending videos using ML-based techniques. Includes functionalities for metadata extraction, content-based filtering, and personalized suggestions.",
    github: "https://github.com/prateekrai1/Video-Processing-and-Recommendation/"
  },
  {
    name: "Cultverse",
    description: "An immersive platform for culture-driven virtual worlds and online communities. Supports content creation, community events, and user collaboration.",
    github: "https://github.com/prateekrai1/Cultverse"
  },
  {
    name: "Pattern Matching (collaborator)",
    description: "A toolkit featuring state-of-the-art pattern matching algorithms for bioinformatics and text processing applications.",
    github: "https://github.com/RajnandiniG/Pattern_Matching"
  }
];


export default projData